// extracted by mini-css-extract-plugin
export default {"div":"home_div__Dpjru"};